import { PaymentConfigSubcategory } from '../../models/paymentConfig';
import client from '../httpclient';

const getPaymentSubcategories = (protocolId: string, categoryId: string):
Promise<PaymentConfigSubcategory[]> => client.get(
  `/re/v1/protocol/${protocolId}/paymentCategory/${categoryId}/paymentSubcategory`,
);

export default getPaymentSubcategories;
